/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCapsule = createReactComponent("outline", "capsule", "IconCapsule", [["path", { "d": "M6 3m0 6a6 6 0 0 1 6 -6h0a6 6 0 0 1 6 6v6a6 6 0 0 1 -6 6h0a6 6 0 0 1 -6 -6z", "key": "svg-0" }]]);

export { IconCapsule as default };
//# sourceMappingURL=IconCapsule.mjs.map
